import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import themesConfig from 'app/fuse-configs/themesConfig'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

import { DISTRESS, AVAILABLE } from 'app/constants/statusColors'

const PanelsWarning = (props) => {
  const { type, children, className, ...rest } = props
  const [style, setStyle] = useState({
    box: 'border-1 border-primary-350 text-primary bg-primary-200',
    icon: 'primary',
  })

  const handleColor = (type) => {
    switch (type) {
      case DISTRESS:
        setStyle({
          box: 'border-1 border-orange-200 text-primary bg-orange-50',
          icon: 'orange-500',
        })
        break
      case AVAILABLE:
        setStyle({
          box: 'border-1 border-sky-200 text-primary bg-sky-50',
          icon: 'sky-500',
        })
        break
      default:
        setStyle({ box: '', icon: '' })
    }
  }

  useEffect(() => {
    handleColor(type)
  }, [type])

  return (
    <Box {...rest} className={clsx('rounded-8 p-5', className, style.box)}>
      <WarningRoundedIcon
        fontSize="small"
        style={{ color: themesConfig.default.colors[style.icon] }}
      />
      {children}
    </Box>
  )
}

PanelsWarning.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
}

export default PanelsWarning
